import { FC } from "react";

interface BackButtonArrowSVGProps {
    className?: string;
}

const BackButtonArrowSVG: FC<BackButtonArrowSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="8"
            height="14"
            viewBox="0 0 8 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7 13L1.14142 7.14142C1.06332 7.06332 1.06332 6.93668 1.14142 6.85858L7 1"
                stroke="#F1F1F1"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default BackButtonArrowSVG;
